import { FormattedMessage } from 'react-intl';

export const dropdownFilterMessages = {
  'dropdownFilter.label': (
    <FormattedMessage id="dropdownFilter.label" defaultMessage="Filter" />
  ),
};
